import {
    GET_USER,
    GET_USER_SCCESS,
    PROFILE_FIRST_NAME_CHANGED,
    PROFILE_LAST_NAME_CHANGED,
    PROFILE_PHONE_CHANGED,
    PROFILE_EMAIL_CHANGED,
    PROFILE_PROVINCE_CHANGED,
    PROFILE_GENDER_CHANGED,
    PROFILE_CITY_CHANGED,
    PROFILE_COUNTRY_CHANGED,
    PROFILE_PROFILE_IMAGE_CHANGED,
    RESET_USER_PROFILE,
    FILL_USER_PROFILE_DATA,
    POST_USER_FEEDBACK,
    POST_CONTACT_US_DATA,
    GET_SAVED_POST_DATA,
    GET_SAVED_POST_DATA_SUCCESS,
    RESET_SAVED_POST_DATA,
    RESET_EVALUATION_DATA,
    EVALUATION_DATA,
    EVALUATION,
    GET_MY_VOTES_DATA,
    GET_MY_VOTES_DATA_SUCCESS,
    PROFILE_COVER_IMAGE_CHANGED,
    USER_CHANGE_PASSWORD_REQUEST,
    USER_CHANGE_PASSWORD_SUCCESS,
    USER_CHANGE_PHONE_NUMBER_REQUEST,
    USER_CHANGE_PHONE_NUMBER_SUCCESS,
    USER_PHONE_NUMBER_VERIFY_REQUEST,
    USER_PHONE_NUMBER_VERIFY_SUCCESS,
    UPDATE_MEDIA_VIEW_COUNT_SAVEDPOST_SUCCESS
} from "../constants/actionTypes";

export const getUser = payload => ({
    type: GET_USER,
    payload
});

export const getUserSuccess = payload => ({
    type: GET_USER_SCCESS,
    payload
});

export const fillUserProfileData = () => ({
    type: FILL_USER_PROFILE_DATA
});

export const profileFirstNameChanged = payload => ({
    type: PROFILE_FIRST_NAME_CHANGED,
    payload
});

export const profileLastNameChanged = payload => ({
    type: PROFILE_LAST_NAME_CHANGED,
    payload
});

export const profilePhoneChanged = payload => ({
    type: PROFILE_PHONE_CHANGED,
    payload
});

export const profileEmailChanged = payload => ({
    type: PROFILE_EMAIL_CHANGED,
    payload
});

export const profileGenderChanged = payload => ({
    type: PROFILE_GENDER_CHANGED,
    payload
});

export const profileCountryChanged = payload => ({
    type: PROFILE_COUNTRY_CHANGED,
    payload
});

export const profileProvinceChanged = payload => ({
    type: PROFILE_PROVINCE_CHANGED,
    payload
});

export const profileCityChanged = payload => ({
    type: PROFILE_CITY_CHANGED,
    payload
});

export const profileProfileImageChanged = payload => ({
    type: PROFILE_PROFILE_IMAGE_CHANGED,
    payload: payload
});

export const profileCoverImageChanged = payload => ({
    type: PROFILE_COVER_IMAGE_CHANGED,
    payload: payload
});

export const resetUserProfile = () => ({
    type: RESET_USER_PROFILE
});

export const postUserFeedback = (payload) => ({
    type: POST_USER_FEEDBACK,
    payload
});

export const postContactUsData = (payload) => ({
    type: POST_CONTACT_US_DATA,
    payload
});

export const getSavedPostData = () => ({
    type: GET_SAVED_POST_DATA
});

export const getMyVotesData = payload => ({
    type: GET_MY_VOTES_DATA,
    payload
});

export const getMyVotesDataSuccess = payload => ({
    type: GET_MY_VOTES_DATA_SUCCESS,
    payload
});


export const getSavedPostDataSuccess = payload => ({
    type: GET_SAVED_POST_DATA_SUCCESS,
    payload
});

export const evaluation = payload => ({
    type: EVALUATION,
    payload
});

export const evaluationData = payload => ({
    type: EVALUATION_DATA,
    payload
});

export const resetEvaluationData = () => ({
    type: RESET_EVALUATION_DATA
});

export const resetSavedPostData = () => ({
    type: RESET_SAVED_POST_DATA
});

export const userChangePasswordRequest = payload => ({
    type: USER_CHANGE_PASSWORD_REQUEST,
    payload
});

export const userChangePasswordSuccess = payload => ({
    type: USER_CHANGE_PASSWORD_SUCCESS,
    payload
});

export const userChangePhoneNumberRequest = payload => ({
    type: USER_CHANGE_PHONE_NUMBER_REQUEST,
    payload
});

export const userChangePhoneNumberSuccess = payload => ({
    type: USER_CHANGE_PHONE_NUMBER_SUCCESS,
    payload
});
export const userPhoneNumberVerifyRequest = payload => ({
    type: USER_PHONE_NUMBER_VERIFY_REQUEST,
    payload
});

export const userPhoneNumberVerifySuccess = payload => ({
    type: USER_PHONE_NUMBER_VERIFY_SUCCESS,
    payload
});
export const updateMediaViewCountSavedPostsSuccess = payload => ({
    type: UPDATE_MEDIA_VIEW_COUNT_SAVEDPOST_SUCCESS,
    payload
});